import { render, staticRenderFns } from "./PayRateNew.vue?vue&type=template&id=12b114e3"
import script from "./PayRateNew.vue?vue&type=script&lang=js"
export * from "./PayRateNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports